// extracted by mini-css-extract-plugin
export default {"selectGroup":"SelectGroup_selectGroup__N2Svw"};